import { render, staticRenderFns } from "./organization-user-update.html?vue&type=template&id=afddb17e&scoped=true&external"
import script from "./organization-user-update.js?vue&type=script&lang=js&external"
export * from "./organization-user-update.js?vue&type=script&lang=js&external"
import style0 from "./organization-user-update.scss?vue&type=style&index=0&id=afddb17e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afddb17e",
  null
  
)

export default component.exports